import table      from "assets/images/chart-images/table.png";
const timePeriodList = [
        {id: "%AFMTP-T01s", name: "table", chartImage: table, v2: "Column", disabled: false},
        {id: "%AFMTP-T01e", name: "table", chartImage: table, v2: "Column", disabled: false},
];

export default timePeriodList;
